// import { useState } from "react";
// import API from "../../Api/axiosConfig";
// import { Form, Container, Row, Col, Card } from "react-bootstrap";
// import MyInput from "../../Components/Myinput";
// import MyButton from "../../Components/MyButton";
// import { useNavigate } from "react-router-dom";

// function Login() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate()
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const res = await API.post("/login", { email, password });

//       // if (res.data.status) {
//       //   localStorage.setItem("token", res.data.data.token);
//       //   navigate("/");
//       //   console.log(res.data.data.message || "تم تسجيل الدخول بنجاح");
//       //   setTimeout(() => {
//       //     navigate("/");
//       //   }, 1500);
//       // }

//       if (res.data.status) {
//         localStorage.setItem("token", res.data.data.token);
//         localStorage.setItem("userType", res.data.data.user.type);

//         if (["admin", "subAdmin"].includes(res.data.data.user.type)) {
//           navigate("/admin/sub-admins");
//         } else {
//           navigate("/");
//         }
//       }

//       console.log(res);

//     } catch (err) {
//       console.log("فشل تسجيل الدخول");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Container fluid className="vh-100 login-con">
//       <Row className="h-100 ">
//         <Col md={6} className="login-image d-none d-md-block"></Col>

//         <Col md={6} className="d-flex justify-content-center align-items-center">
//           <Card className="shadow-lg p-5 rounded-4 login-card w-75">
//             <Card.Body dir="rtl">
//               <h2 className="text-center mb-4">تسجيل الدخول</h2>
//               <Form onSubmit={handleSubmit}>
//                 <MyInput
//                   label="البريد الإلكتروني"
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                 />
//                 <MyInput
//                   label="كلمة المرور"
//                   type="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                 />
//                 <MyButton text="تسجيل الدخول" loading={loading} />
//               </Form>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// }

// export default Login;

import { useState } from "react";
import API from "../../Api/axiosConfig";
import { Form, Container, Row, Col, Card } from "react-bootstrap";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 تسجيل الدخول العادي
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await API.post("/login", { email, password });

      if (res.data.status) {
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("userType", res.data.data.user.type);

        if (["admin", "subAdmin"].includes(res.data.data.user.type)) {
          navigate("/admin/sub-admins");
        } else {
          navigate("/dashboard");
        }
      }
    } catch (err) {
      console.log("فشل تسجيل الدخول");
    } finally {
      setLoading(false);
    }
  };

  //  تسجيل الدخول باستخدام Google
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const token = credentialResponse.credential;

      // ابعت التوكن للسيرفر (Laravel)
      const response = await API.post("/auth/google", { token });

      // console.log("User Data:", response.data);

      // مثال للتخزينّ
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("userType", response.data.user?.type || "user");

      if (["admin", "subadmin"].includes(response.data.user?.type)) {
        navigate("/admin/sub-admins");
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Google login error:", error);
    }
  };

  const handleGoogleError = () => {
    console.log("فشل تسجيل الدخول بـ Google");
  };

  return (
    <Container fluid className="vh-100 login-con">
      <Row className="h-100 ">
        <Col md={6} className="login-image d-none d-md-block"></Col>

        <Col
          md={6}
          className="d-flex justify-content-center align-items-center">
          <Card className="shadow-lg p-5 rounded-4 login-card w-75">
            <Card.Body dir="rtl">
              <h2 className="text-center mb-4">تسجيل الدخول</h2>

              {/* تسجيل الدخول العادي */}
              <Form onSubmit={handleSubmit}>
                <MyInput
                  label="البريد الإلكتروني"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <MyInput
                  label="كلمة المرور"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <MyButton text="تسجيل الدخول" loading={loading} />
              </Form>

              {/* فاصل بسيط */}
              <div className="text-center my-3">أو</div>

              {/* تسجيل الدخول بـ Google */}
<div className="google-login-container">
  <GoogleLogin
    onSuccess={handleGoogleSuccess}
    onError={handleGoogleError}
  />
</div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
